import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'
import { App } from '../../App';
import { Surface, Stack, SmartContainer } from '../../styles/Containers'
import { StyledH1, StyledH3, StyledP } from '../../styles/StyledHTML'
import { StyledButton } from '../../styles/matieralui/Button'
import { IconLock } from '../../capturecollab/Icons';
import { StyledLockIcon } from '../../capturecollab/modules/Permission/NoPermissions';
export const PaymentRestrictionPage = ({ account }) => {

    const dispatch = useDispatch();

    const goTo = (path) => dispatch(push(path))

    const title = (account.paymentStatus === 'failed') ? 'Update Your Payment Info' : 'Reactivate Your Account';
    const message = (account.paymentStatus === 'failed') ? 'Update your card on file to regain access.' : 'Reactivate your account by going to billing.';
    const buttonText = (account.paymentStatus === 'failed') ? 'Update Card' : 'Reactive Account';

    return (
        <App title={title}>

            <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
                <SmartContainer maxWidth="450px" textAlign="center">
                    <SmartContainer flex align="center" justify="center" width="100%"><StyledLockIcon><IconLock color="white" /></StyledLockIcon></SmartContainer>
                    <br />
                    <StyledH1>{title}</StyledH1>
                    <br />
                    <StyledP>{message}</StyledP>
                    <br />
                    <StyledP><StyledButton variant='contained' color='blue' onClick={() => goTo('/billing')}>{buttonText}</StyledButton></StyledP>
                </SmartContainer>
            </SmartContainer>

        </App>
    )
}